import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
export var fixedWidthContainerStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: var(--link-picker-width);\n"])));